(function() {
  if (window.ProductFormInitialized) return;
  window.ProductFormInitialized = true;

  class ProductForm extends HTMLElement {
    constructor() {
      super();   
      this.form = this.querySelector('form');
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: ['grim-drawer'],
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.updateDrawerContents(parsedState);
          window.drawer.open('grim-drawer');
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }

    updateDrawerContents(parsedState) {
      const drawerElement = document.getElementById('grim-drawer');
      if (drawerElement) {
        const drawerBody = drawerElement.querySelector('.drawer-body');
        if (drawerBody) {
          const newContent = this.getSectionInnerHTML(parsedState.sections['grim-drawer'], '.drawer-body');
          drawerBody.innerHTML = newContent;

          // Update the drawer class based on cart contents
          if (drawerBody.querySelector('.cart__drawer-items').children.length > 0) {
            drawerElement.classList.remove('cart-empty');
            drawerElement.classList.add('cart-has-items');
          } else {
            drawerElement.classList.remove('cart-has-items');
            drawerElement.classList.add('cart-empty');
          }

          // Update cart count if it exists
          const cartCount = drawerBody.querySelector('.cart-count');
          if (cartCount) {
            const existingCartCount = document.querySelector('.cart-count');
            if (existingCartCount) {
              existingCartCount.textContent = cartCount.textContent;
            }
          }

          // Update cart total if needed
          const cartTotal = drawerBody.querySelector('#cart-total-price');
          if (cartTotal) {
            const existingCartTotal = document.querySelector('#cart-total-price');
            if (existingCartTotal) {
              existingCartTotal.textContent = cartTotal.textContent;
            }
          }
        }
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  // Initialize all product forms
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-form').forEach(form => {
      if (!form.initialized) {
        new ProductForm(form);
        form.initialized = true;
      }
    });
  });
})();
